import React from 'react'
import { Link, useLocation } from 'react-router-dom';

function FooterThree() {
    const location = useLocation();

    const handleLogoClick = (e) => {
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            window.history.pushState(null, null, '/');
        }
    };

    return (
        <div>
            {/* rts footer three area start */}
            <div className="rts-footer-area footer-three rts-section-gapTop footer-bg-2">
                <div className="container pb--100 pb_sm--40">
                    <div className="row g-5">
                        <div className="col-xl-4 col-lg-4">
                            <div className="footer-three-single-wized left">
                                <Link to={'/'} className="logo_footer" onClick={handleLogoClick}>
                                    <img src={`${process.env.PUBLIC_URL}/assets/images_new/logo.png`} alt="Izodrom Grup Logo" />
                                </Link>
                                <p className="disc">
                                    Izodrom Grup - lider în sectorul construcțiilor și infrastructurii inginerești din Republica Moldova. 
                                    Peste 20 de ani de expertiză în proiecte complexe de infrastructură durabilă.
                                </p>
                            </div>
                        </div>
                        {/* footer contact area */}
                        <div className="col-xl-4 col-lg-4">
                            <div className="footer-three-single-wized mid-left">
                                <h5 className="title">Informații Contact</h5>
                                <div className="body">
                                    <div className="info-wrapper">
                                        <div className="single">
                                            <ul className="icon">
                                                <li>
                                                    <i className="fas fa-phone-alt" />
                                                </li>
                                            </ul>
                                            <div className="info">
                                                <span>Telefon</span>
                                                <Link to={'tel:+37326825763'}>+373 268 25-763</Link>
                                            </div>
                                        </div>
                                        <div className="single">
                                            <ul className="icon">
                                                <li>
                                                    <i className="far fa-envelope" />
                                                </li>
                                            </ul>
                                            <div className="info">
                                                <span>Email</span>
                                                <Link to={'mailto:office@izodrom.md'}>office@izodrom.md</Link>
                                            </div>
                                        </div>
                                        <div className="single">
                                            <ul className="icon">
                                                <li>
                                                    <i className="fas fa-map-marker-alt" />
                                                </li>
                                            </ul>
                                            <div className="info">
                                                <span>Adresa</span>
                                                <Link to={'#'}>
                                                    Str. Ialoveni nr. 2, Ialoveni<br />
                                                    MD-6801, Republica Moldova
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="single">
                                            <ul className="icon">
                                                <li>
                                                    <i className="fas fa-id-card" />
                                                </li>
                                            </ul>
                                            <div className="info">
                                                <span>IDNO</span>
                                                <Link to={'#'}>1003600020891</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* footer services area */}
                        <div className="col-xl-4 col-lg-4">
                            <div className="footer-three-single-wized mid-right">
                                <h5 className="title">Serviciile Noastre</h5>
                                <div className="body">
                                    <div className="update-wrapper">
                                        <p className="disc">
                                            Specializăm în construcții civile și industriale, lucrări de terasamente, 
                                            sisteme de alimentare cu apă și canalizare, stații de epurare și montaj protecție.
                                        </p>
                                        <div className="services-list">
                                            <ul>
                                                <li>Construcții civile și industriale</li>
                                                <li>Lucrări de terasamente</li>
                                                <li>Sisteme de alimentare cu apă</li>
                                                <li>Stații de epurare a apelor uzate</li>
                                                <li>Montaj protecție și finisaje</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright-area ptb--20">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <p className="disc text-center">
                                    Izodrom Grup - Copyright 2025. Toate drepturile rezervate. | 
                                    Partenerul dumneavoastră de încredere pentru infrastructură durabilă și dezvoltare regională.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts footer three area end */}
        </div>
    )
}

export default FooterThree